import type { Resource } from '../../';
export const search_box_frame_suggestedProducts: Resource = {"default":"Suggested Products"};
